// extracted by mini-css-extract-plugin
export var askAiIcon = "_ke-9";
export var container = "_ke-0";
export var groupSeparator = "_ke-a";
export var highlight = "_ke-4";
export var resultIcon = "_ke-5";
export var resultItem = "_ke-7";
export var resultSubtitle = "_ke-3";
export var resultTitle = "_ke-2";
export var resultsList = "_ke-1";
export var searchGroup = "_ke-6";
export var selected = "_ke-8";